module.exports = __webpack_public_path__ + "img/image.caf49ed9.png";